import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import {
  AuthGuard,
  LogoutGuard,
  MultiAgentSessionGuard,
  PageNotFoundComponent,
  PasswordRenewalGuard,
  RouteKey,
  TileId,
  TilesGuard,
} from '@contact/upgrade';

import { AuthCookieGuard } from './guards/auth-cookie.guard';

export enum Path {
  // base
  login = 'login',
  logout = 'logout',
  portal = 'portal',

  // tiles
  agent = 'agent',
  engagement = 'engagement',
  history = 'history',
  hypervision = 'hypervision',
  responder = 'responder',
  tracking = 'tracking',
  wallboard = 'wallboard',
  wallboardConf = 'wallboard-conf',

  // specific
  redirectTo = 'auth',
}

const routes: Routes = [
  { path: '', redirectTo: Path.login, pathMatch: 'full' },
  {
    path: Path.login,
    canDeactivate: [PasswordRenewalGuard],
    loadChildren: () => import('@login/login.module').then(m => m.LoginModule),
  },
  {
    path: Path.logout,
    canActivate: [LogoutGuard],
    loadChildren: () => import('@login/login.module').then(m => m.LoginModule),
  },
  {
    path: Path.portal,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('@portal/portal.module').then(m => m.PortalModule),
    data: {
      [RouteKey.TileId.key]: TileId.PORTAL,
    },
  },
  {
    path: Path.agent,
    canLoad: [AuthGuard, TilesGuard],
    canActivate: [AuthGuard, MultiAgentSessionGuard],
    loadChildren: () => import('@agent/agent.module').then(m => m.AgentModule),
    data: {
      [RouteKey.TileId.key]: TileId.CSR,
    },
  },
  {
    path: Path.engagement,
    canLoad: [AuthGuard, TilesGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('@engagement/engagement.module').then(m => m.EngagementModule),
    data: {
      [RouteKey.TileId.key]: TileId.ENGAGEMENT,
    },
  },
  {
    path: Path.history,
    canLoad: [AuthGuard, TilesGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('@history/history.module').then(m => m.HistoryModule),
    data: {
      [RouteKey.TileId.key]: TileId.HISTORIZATION,
    },
  },
  {
    path: Path.hypervision,
    canLoad: [AuthGuard, TilesGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('@hypervision/hypervision.module').then(m => m.HypervisionModule),
    data: {
      [RouteKey.TileId.key]: TileId.HYPERVISOR,
    },
  },
  {
    path: Path.responder,
    canLoad: [AuthGuard, TilesGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('@responder/responder.module').then(m => m.ResponderModule),
    data: {
      [RouteKey.TileId.key]: TileId.RESPONDER,
    },
  },
  {
    path: Path.tracking,
    canLoad: [AuthGuard, TilesGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('@tracking/tracking.module').then(m => m.TrackingModule),
    data: {
      [RouteKey.TileId.key]: TileId.USER_TRACKING,
    },
  },
  {
    path: Path.wallboard,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('@wallboard/wallboard.module').then(m => m.WallboardModule),
    data: {
      [RouteKey.TileId.key]: TileId.WALLBOARD_CUSTOM,
    },
  },
  {
    path: Path.wallboardConf,
    canLoad: [AuthGuard, TilesGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('@wallboard-conf/wallboard-conf.module').then(m => m.WallboardConfModule),
    data: {
      [RouteKey.TileId.key]: TileId.WALLBOARD_CONFIG,
    },
  },
  {
    path: Path.redirectTo,
    canActivate: [AuthCookieGuard],
    loadChildren: () => import('@redirect-to/redirect-to.module').then(m => m.RedirectToModule),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'disabled',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
